import * as React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import { ReduxInput, ReduxSelect } from 'components/FormElements/ReduxForm'
// constants
import { Forms } from 'constants/index'
// types
import { IField, IObjectEntityReviewQuestion } from 'types/graphql'
// views
import { Form, Label } from './views'

interface IIncomingProps {
  questions: IObjectEntityReviewQuestion[]
  picklists: IField[]
  isReviewView?: boolean
}

const CreateReviewForm: React.FunctionComponent<InjectedFormProps & IIncomingProps> = ({
  questions,
  picklists,
  handleSubmit,
  isReviewView
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Grid>
        <Label>{questions?.[0]?.text || 'Question 1. Please refresh the page to see the question.'}</Label>
        <ReduxInput disabled={isReviewView} multiline name={'goals'} />
      </Grid>
      <Grid>
        <Label>{questions?.[1]?.text || 'Question 2. Please refresh the page to see the question.'}</Label>
        <ReduxInput disabled={isReviewView} multiline name={'doWell'} />
      </Grid>
      <Grid>
        <Label>{questions?.[2]?.text || 'Question 3. Please refresh the page to see the question.'}</Label>
        <ReduxInput disabled={isReviewView} multiline name={'doBetter'} />
      </Grid>
      {picklists.map((item) => (
        <Grid key={item.id}>
          <ReduxSelect
            label={item.label}
            isDisabled={isReviewView}
            isMultiple={item.multiple}
            isClearable={!item.multiple}
            name={`picklists.${item.id}`}
            placeholder={'Select option'}
            options={(item.options || [])
              .filter((option) => option.active)
              .map((option) => ({ label: option.label, value: option.id }))}
          />
        </Grid>
      ))}
    </Form>
  )
}

export default reduxForm<any, any>({
  enableReinitialize: true,
  form: Forms.CREATE_REVIEW_FORM
})(CreateReviewForm)
